// extracted by mini-css-extract-plugin
module.exports = {"noResultWrap":"noResultWrap--3cig3","title":"title--nOh5K","search":"search--2Scwa"};